var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/connections/NotForSale/SellForMoreShowcaseUpsell/SellForMoreShowcaseUpsellWrapper.jsx";

import React from 'react';
import PropTypes from 'prop-types';
import { useYieldCallback } from '@zillow/yield-callback';
import { appendQueryParameter } from '../../../../../utils/stringUtils';
import SellForMoreShowcaseUpsellTemplate from './SellForMoreShowcaseUpsellTemplate';
import { formNewLaneEventPayload } from '../../../../../eventing/newLaneEventPayload';
import { CLICKSTREAM_EVENT_TYPE } from '../../../../../eventing/clickStreamEventSchema';
import { useOnsiteMessagingClickstreamImpressionEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingClickstreamImpressionEvent';
import { useOnsiteMessagingClickstreamIntentToShowEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingClickstreamIntentToShowEvent';
import { ClickstreamEvent } from '../../../../../eventing/ClickstreamEvent';
export var SellForMoreShowcaseUpsell = function SellForMoreShowcaseUpsell(_ref) {
  var titleText = _ref.titleText,
      subtitleText = _ref.subtitleText,
      subtitleTextTooltipHeading = _ref.subtitleTextTooltipHeading,
      subtitleTextTooltipBody = _ref.subtitleTextTooltipBody,
      subtitleTextTooltipButtonActionLink = _ref.subtitleTextTooltipButtonActionLink,
      subtitleTextTooltipButtonText = _ref.subtitleTextTooltipButtonText,
      firstRowText = _ref.firstRowText,
      firstRowTextTooltipHeading = _ref.firstRowTextTooltipHeading,
      firstRowTextTooltipBody = _ref.firstRowTextTooltipBody,
      firstRowTextTooltipButtonActionLink = _ref.firstRowTextTooltipButtonActionLink,
      firstRowTextTooltipButtonText = _ref.firstRowTextTooltipButtonText,
      percentIncrease = _ref.percentIncrease,
      secondRowText = _ref.secondRowText,
      emphasizePercent = _ref.emphasizePercent,
      thirdRowText = _ref.thirdRowText,
      thirdRowSubText = _ref.thirdRowSubText,
      standingOfferPrice = _ref.standingOfferPrice,
      emphasizeShowcase = _ref.emphasizeShowcase,
      actionText = _ref.actionText,
      actionLink = _ref.actionLink,
      forceColumnLayout = _ref.forceColumnLayout,
      trackingParameter = _ref.trackingParameter,
      zpid = _ref.zpid,
      additionalProps = _ref.additionalProps,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData;
  var signalForTriggerTracking = additionalProps.signalForTriggerTracking;
  var ref = useOnsiteMessagingClickstreamImpressionEvent({
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  useOnsiteMessagingClickstreamIntentToShowEvent({
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData,
    signalForTriggerTracking: signalForTriggerTracking
  });
  var questionnaireLink = appendQueryParameter(actionLink, trackingParameter, zpid);
  var onActionButtonClick = useYieldCallback(function () {
    ClickstreamEvent(formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.INTERACTION, newLaneEventData, additionalClickStreamData));

    if (actionLink) {
      window.open(questionnaireLink, '_blank');
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(SellForMoreShowcaseUpsellTemplate, {
    titleText: titleText,
    subtitleText: subtitleText,
    subtitleTextTooltipHeading: subtitleTextTooltipHeading,
    subtitleTextTooltipBody: subtitleTextTooltipBody,
    subtitleTextTooltipButtonActionLink: subtitleTextTooltipButtonActionLink,
    subtitleTextTooltipButtonText: subtitleTextTooltipButtonText,
    firstRowText: firstRowText,
    firstRowTextTooltipHeading: firstRowTextTooltipHeading,
    firstRowTextTooltipBody: firstRowTextTooltipBody,
    firstRowTextTooltipButtonActionLink: firstRowTextTooltipButtonActionLink,
    firstRowTextTooltipButtonText: firstRowTextTooltipButtonText,
    percentIncrease: percentIncrease,
    secondRowText: secondRowText,
    emphasizePercent: emphasizePercent,
    thirdRowText: thirdRowText,
    thirdRowSubText: thirdRowSubText,
    standingOfferPrice: standingOfferPrice,
    emphasizeShowcase: emphasizeShowcase,
    actionText: actionText,
    onActionButtonClick: onActionButtonClick,
    forceColumnLayout: forceColumnLayout,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 13
    }
  }));
};
SellForMoreShowcaseUpsell.propTypes = process.env.NODE_ENV !== "production" ? {
  titleText: PropTypes.string,
  subtitleText: PropTypes.string,
  subtitleTextTooltipHeading: PropTypes.string,
  subtitleTextTooltipBody: PropTypes.string,
  subtitleTextTooltipButtonActionLink: PropTypes.string,
  subtitleTextTooltipButtonText: PropTypes.string,
  firstRowText: PropTypes.string,
  firstRowTextTooltipHeading: PropTypes.string,
  firstRowTextTooltipBody: PropTypes.string,
  firstRowTextTooltipButtonActionLink: PropTypes.string,
  firstRowTextTooltipButtonText: PropTypes.string,
  percentIncrease: PropTypes.string,
  secondRowText: PropTypes.string,
  emphasizePercent: PropTypes.bool,
  thirdRowText: PropTypes.string,
  thirdRowSubText: PropTypes.string,
  standingOfferPrice: PropTypes.string,
  emphasizeShowcase: PropTypes.bool,
  actionText: PropTypes.string,
  trackingParameter: PropTypes.string,
  zpid: PropTypes.string,
  actionLink: PropTypes.string,
  forceColumnLayout: PropTypes.bool,
  additionalProps: PropTypes.shape({
    signalForTriggerTracking: PropTypes.bool
  }),
  // eslint-disable-next-line zillow/react/forbid-prop-types
  newLaneEventData: PropTypes.object,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalClickStreamData: PropTypes.object
} : {};
SellForMoreShowcaseUpsell.defaultProps = {
  titleText: '',
  subtitleText: '',
  subtitleTextTooltipHeading: '',
  subtitleTextTooltipBody: '',
  subtitleTextTooltipButtonActionLink: '',
  subtitleTextTooltipButtonText: '',
  firstRowText: '',
  firstRowTextTooltipHeading: '',
  firstRowTextTooltipBody: '',
  firstRowTextTooltipButtonActionLink: '',
  firstRowTextTooltipButtonText: '',
  percentIncrease: '',
  secondRowText: '',
  emphasizePercent: false,
  thirdRowText: '',
  thirdRowSubText: '',
  standingOfferPrice: '',
  emphasizeShowcase: false,
  actionText: '',
  trackingParameter: '',
  zpid: null,
  actionLink: '',
  forceColumnLayout: false,
  additionalProps: {},
  newLaneEventData: {},
  additionalClickStreamData: {}
};